import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { httpRequest } from "../utils/httpRequest";
import { toast } from "react-toastify";
import { redirectToDashboard } from "./LoginPage";
const AuthMagicLoginPage = () => {
  const location = useLocation();
  const [loading , setLoading] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) return;

    (async () => {
      try {
        setLoading(true);

        const { data } = await httpRequest("POST", "/user/auth/magic-login", {
          token,
        });

        const user = data?.data;
        localStorage.setItem("user", JSON.stringify(user));

        toast.success("ورود موفق");

        redirectToDashboard(user);
      } catch (err) {
        toast.error("لینک نامعتبر یا منقضی شده");
      } finally {
        setLoading(false);
      }
    })();
  }, [location.search]);

  return <div></div>;
};

export default AuthMagicLoginPage;
